import React from 'react';
import { connect } from 'react-redux';
import { times } from 'lodash';
import { I18n } from 'react-redux-i18n';

import { onValueChange } from './reducer';

import { Icon } from 'semantic-ui-react';

import ConverterHelper from "../../helpers/converterHelper";
import { getSmallImageUrl } from "../../helpers/imageHelper";
import { campaignGiftMatchingConditionSettings } from './giftMatching';
import { isArrayWithItems } from '../../helpers/arrayHelper';
import { ReactComponent as GiftIcon } from "../../semantic/assets/images/giftIcon.svg";

export class GiftMatchingWidgetContainer extends React.Component {
    handleMoveForward = () => {
        if (this.props.activeIndex < this.props.giftMatching.length - 1) {
            this.props.onValueChange('giftMatching.activeIndex', this.props.activeIndex + 1);
        }
    }

    handleMoveBack = () => {
        if (this.props.activeIndex > 0) {
            this.props.onValueChange('giftMatching.activeIndex', this.props.activeIndex - 1);
        }
    }

    render() {
        const colorRGB = ConverterHelper.hexToRgb(this.props.primaryColor) || { r: 19, g: 240, b: 142};
        const moveBackDisabled = this.props.activeIndex === 0;
        const moveForwardDisabled = this.props.activeIndex === this.props.giftMatching.length - 1;
        const conditions = isArrayWithItems(this.props.giftMatching) && this.props.giftMatching[this.props.activeIndex].conditions.map(item => campaignGiftMatchingConditionSettings[item.key].getLabel(item.value[0], item.operator)).join('');
        const mainImagePath = isArrayWithItems(this.props.giftMatching) && this.props.giftMatching[this.props.activeIndex].mainImagePath && getSmallImageUrl(this.props.giftMatching[this.props.activeIndex].mainImagePath);

        return (
            <React.Fragment>
                {
                    isArrayWithItems(this.props.giftMatching) &&
                    <div
                        className="gift-matching-container"
                        style={{ backgroundColor: `rgba(${colorRGB.r},${colorRGB.g},${colorRGB.b},0.1)` }}>
                        <div className="gift-matching-inner-container">
                            {mainImagePath && <div className="gift-matching-logo">
                                <img src={mainImagePath} alt=""/>
                            </div>}
                            <div className="gift-matching-icon" style={{ color: this.props.primaryColor }}>
                                {
                                    React.Children.toArray(
                                        times(this.props.giftMatching[this.props.activeIndex].multiplier + 1, () => <GiftIcon height="36px" width="36px" />)
                                    )
                                }
                            </div>
                            <div className="gift-matching-title" style={{ color: this.props.primaryColor }}>
                                {I18n.t("giftMatching.multiplier.label", { multiplier: I18n.t(`giftMatching.multiplier.${this.props.giftMatching[this.props.activeIndex].multiplier + 1}`) })}
                            </div>
                            <div className="gift-matching-text">
                                {I18n.t("giftMatching.content",
                                    {
                                        donationFrom: this.props.giftMatching[this.props.activeIndex].donation.from || I18n.t("giftMatching.donation.from.default"),
                                        multiplier: I18n.t(`giftMatching.multiplier.${this.props.giftMatching[this.props.activeIndex].multiplier}`).toLowerCase(),
                                        conditions: conditions
                                    }
                                )}
                            </div>
                        </div>
                        {
                            this.props.giftMatching.length > 1 &&
                            <div className="gift-matching-navigation">
                                <div className="move-back-icon">
                                    <Icon name="arrow left" onClick={this.handleMoveBack} disabled={moveBackDisabled} />
                                </div>

                                <span className="number-of-giftMatching">
                                    {I18n.t("giftMatching.navigation",
                                        {
                                            current: this.props.activeIndex + 1,
                                            count: this.props.giftMatching.length,
                                        }
                                    )}
                                </span>

                                <div className="move-forward-icon">
                                    <Icon name="arrow right" onClick={this.handleMoveForward} disabled={moveForwardDisabled} />
                                </div>
                            </div>
                        }
                    </div>
                }
            </React.Fragment>
        );
    }
}

const mapState = state => {
    const organization = state?.page?.organization;
    const campaign = state?.page?.campaign;
    const collection = state?.page?.collection;
    const team = state?.page?.team;
    const fundraiser = state?.page?.fundraiser;
    let giftMatching = state?.page?.campaign?.giftMatching || [];

    giftMatching = giftMatching.filter(item => {
        return item.conditions.every(x => {
            return campaignGiftMatchingConditionSettings[x.key].isActive(item, x, campaign, collection, team, fundraiser, organization)
        });
    });

    return {
        activeIndex: 0,
        primaryColor: state?.page?.campaign?.primaryColor || state?.page?.campaign?.template?.value?.style?.primaryColor || state?.page?.organization?.primaryColor,
        giftMatching
    };
};

const mapDispatch = (dispatch) => {
    return {
        onValueChange(path, value) {
            dispatch(onValueChange(path, value));
        },
    };
};

const GiftMatchingWidget = connect(mapState, mapDispatch)(GiftMatchingWidgetContainer);
export default GiftMatchingWidget;